import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { PARTICIPANT_ACTOR_KEY } from '@dadohr/shared/domainTypes/experience';
import {
  Schedule,
  ScheduleChannelType,
  ScheduleType
} from '@dadohr/shared/domainTypes/schedules';

export const toScheduleDoc = generateToDocFn<Schedule>((d) => {
  if (d.type !== ScheduleType.EXPERIENCE_START) {
    d.channel =
      (d.channel as any) === ScheduleChannelType.EMAIL
        ? { type: ScheduleChannelType.EMAIL, emailFrom: 'email' }
        : d.channel;
  }
  d.actor = d.actor || PARTICIPANT_ACTOR_KEY;
  return d;
});
